import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { authActions } from "../../../redux/actions/auth.action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Controller } from "react-hook-form";
import { Password } from "primereact/password";
import { translationConstants } from "../../../constants";

const NewPassword = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const language = useSelector((state) => {
    return state.LanguageChangeReducer.language;
  });

  useEffect(() => {
    i18n.changeLanguage(language);
    document.body.dir = direction;
    // eslint-disable-next-line
  }, [language]);

  const {
    handleSubmit,
    formState: { errors },
    getValues,
    control,
  } = useForm();

  const onSubmit = async (data) => {
    const { newPassword } = data;
    const url = new URL(window.location.href);
    const userId = url.searchParams.get("userId");
    const token = url.searchParams.get("token");
    const code = url.searchParams.get("code");
    // Combine with form data
    const formData = {
      userId: userId,
      token: token,
      code: code,
      newPassword: newPassword,
    };
    dispatch(authActions.resetPassword(formData, navigate));
  };

  return (
      <Form noValidate className="ForgotForm" onSubmit={handleSubmit(onSubmit)}>
        <span className="ForgotParaHeading">
          {t(translationConstants.resetPassword)}
        </span>
        <span className="recoveryPara">
          {t(translationConstants.setNewPassword)}
        </span>

        <Form.Group className="form-group confirmPasswordDiv">
          <Form.Label className="Form-labels">
            {t(translationConstants.enterNewPassword)}
          </Form.Label>
          <Controller
            name="newPassword"
            control={control}
            rules={{
              required: t(translationConstants.newPasswordRequired),
              pattern: {
                value:
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                message: t(translationConstants.passwordValidation),
              },
            }}
            render={({ field }) => (
              <Password
                placeholder={t(translationConstants.newPasswordPlaceholder)}
                {...field}
                toggleMask
                feedback={false}
              />
            )}
          />
          {errors.newPassword && (
            <p className="errorText">{errors.newPassword.message}</p>
          )}
        </Form.Group>

        <Form.Group className="form-group">
          <Form.Label className="Form-labels">
            {t(translationConstants.confirmNewPassword)}
          </Form.Label>
          <Controller
            name="confirmPassword"
            control={control}
            rules={{
              required: t(translationConstants.confirmPasswordRequired),
              validate: (value) =>
                value === getValues("newPassword") ||
                t(translationConstants.passwordsDoNotMatch),
            }}
            render={({ field }) => (
              <Password
                placeholder={t(
                  translationConstants.confirmnewPasswordPlaceholder
                )}
                {...field}
                toggleMask
                feedback={false}
              />
            )}
          />
          {errors.confirmPassword && (
            <p className="errorText">{errors.confirmPassword.message}</p>
          )}
        </Form.Group>

        <Button className="Submit-button " type="submit">
          {t(translationConstants.submit)}
        </Button>
      </Form>
  );
};

export default NewPassword;
